import { memberQueryKeys, memberSearchQueryFn } from "@gymflow/api";
import { LeadDTO, UserMemberBean } from "@gymflow/types";
import { InfiniteData, infiniteQueryOptions } from "@tanstack/react-query";
import useGymflowModels from "apps/portal/src/store";
import { useState } from "react";

import { OptionType } from "./components/OptionsList/components/OptionItem";
import { SearchInput, SearchInputProps } from "./SearchInput";

type UserOrLeadType = UserMemberBean | LeadDTO;

export type UsersSearchInputOptionType = OptionType<UserOrLeadType>;

export type UsersSearchInputOptionsType = OptionType<UserOrLeadType>[];

export type UsersSearchInputProps = Pick<
  SearchInputProps<UserOrLeadType>,
  | "label"
  | "value"
  | "onChange"
  | "dropPosition"
  | "isMulti"
  | "withImageByDefault"
  | "className"
>;

const SEARCH_LIST_SIZE = 10;

export const UsersSearchInput = (props: UsersSearchInputProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const { api } = useGymflowModels();

  return (
    <SearchInput
      {...props}
      dataFetchingQuery={(searchTermLocal) =>
        infiniteQueryOptions({
          queryKey: memberQueryKeys.search(searchTermLocal, SEARCH_LIST_SIZE),
          queryFn: async () => {
            setSearchTerm(searchTermLocal);

            return await memberSearchQueryFn(api, {
              term: searchTermLocal,
              size: SEARCH_LIST_SIZE,
            });
          },
          select: (data) => {
            const { pageParams, pages } = data as InfiniteData<
              UserOrLeadType[]
            >;

            const transformedPages = pages.map((page) =>
              page.map((user) => ({
                id: user.id,
                label: `${user.firstName} ${user.lastName}`,
                value: user,
                imageUrl: "picture" in user ? user.picture : undefined,
                subLabel: user.email,
              })),
            );

            return {
              pageParams,
              pages: transformedPages,
            };
          },
          initialPageParam: undefined,
          getNextPageParam: () => undefined,
          enabled: searchTermLocal.trim().length > 0,
        })
      }
      notFoundClassName="justify-start"
      notFound={!searchTerm.trim() && "Type the name of the member to select"}
    />
  );
};
